import { accessor } from '@redviking/argonaut-core-ui/src/store';
import { camelToTitle } from '@redviking/argonaut-util/src/mes/appletUtil';
import type { Latest } from '@redviking/argonaut-util/types/mes/applet-designs/appletDesign.latest.zod';
import type { FlowNodeControl } from '../../controls/FlowNodeControl';

export function tabGroupItems (): FlowNodeControl.Configs.Selection.SelectionItem[] {
    const entityData = accessor.entityAsType('appletDesignVersion');
    if (!entityData) {
        return [];
    }
    const items: FlowNodeControl.Configs.Selection.SelectionItem[] = [];
    for (const screen of entityData.config.screens) {
        for (const aspectRatio in screen.gridLayoutAspectRatios) {
            const layout = screen.gridLayoutAspectRatios[aspectRatio as keyof typeof screen.gridLayoutAspectRatios];
            for (const cell of layout.linkedGridCells) {
                if (cell.type === 'tabGroup') {
                    items.push({
                        value: cell.id,
                        label: `${screen.name} - ${camelToTitle(aspectRatio)} - ${cell.name}`,
                    });
                }
            }
        }
    }
    return items;
}

export function findTabGroup (tabGroupId: string): Latest.Screen.Designer.TabGroupCell | null {
    const entityData = accessor.entityAsType('appletDesignVersion');
    if (!entityData) {
        return null;
    }
    for (const screen of entityData.config.screens) {
        for (const aspectRatio in screen.gridLayoutAspectRatios) {
            const layout = screen.gridLayoutAspectRatios[aspectRatio as keyof typeof screen.gridLayoutAspectRatios];
            const tabGroup = layout.linkedGridCells.find((cell): cell is Latest.Screen.Designer.TabGroupCell => cell.type === 'tabGroup' && cell.id === tabGroupId);
            if (tabGroup) {
                return tabGroup;
            }
        }
    }
    return null;
}

export function findTabs (tabGroupId: string): Latest.Screen.Designer.TabInstanceCell[] | null {
    const entityData = accessor.entityAsType('appletDesignVersion');
    if (!entityData) {
        return null;
    }
    for (const screen of entityData.config.screens) {
        for (const aspectRatio in screen.gridLayoutAspectRatios) {
            const layout = screen.gridLayoutAspectRatios[aspectRatio as keyof typeof screen.gridLayoutAspectRatios];
            if (layout.linkedGridCells.some(cell => cell.type === 'tabGroup' && cell.id === tabGroupId)) {
                return layout.linkedGridCells.filter((cell): cell is Latest.Screen.Designer.TabInstanceCell => cell.type === 'tabInstance' && cell.parentGridId === tabGroupId);
            }
        }
    }
    return null;
}

export function tabGroupError (tabGroupId: string): string | undefined {
    if (!tabGroupId) {
        return 'Tab group is required';
    }
    return findTabGroup(tabGroupId) ? undefined : 'Tab group ID does not exist in any screen';
}
